import {
    TranslateFunction,
    translateText,
    TranslationDictionary
} from "@ds/base";
import { languages } from "./languages/languages";

export function fetchTranslationFunction(
    locale: string
): Promise<TranslateFunction> {
    return new Promise((resolve) => {
        resolve(createTranslationFunction(locale));
    });
}

export function createTranslationFunction(locale?: string): TranslateFunction {
    if (!locale) {
        locale = "en";
    }

    const translationDictionary = fetchLanguageDictionary(locale);
    const translateFn: TranslateFunction = (textId, substitutionData) => {
        return translateText(textId, [translationDictionary], substitutionData);
    };
    return translateFn;
}

function fetchLanguageDictionary(locale: string): TranslationDictionary {
    const dictionary = languages[locale];

    if (!dictionary) {
        return languages["en"];
    }

    return dictionary;
}
